import { React, Component, Container, _, Route } from 'utils';
import { App } from 'model';
import { Menu, Loading } from 'components';
import { PavilionStore } from 'model';
import { Pavilions } from 'components';

import './homepage.less';

class Homepage extends Component {

	static getStores() {
		return [ PavilionStore ];
	}

	static calculateState() {

		var state = PavilionStore.getState();

		if(state.data != null) {

			var { backgroundURL:location, pavilions } = state.data;
			var url = App.url(location);

			return {
				pavilions: pavilions,
				background: url,
				loading: false,
				title: state.data.name
			}
		} else {
			return {
				pavilions: [],
				background: null,
				loading: true,
				title: ''
			}
		}

	}

	render() {

		var { background, loading, pavilions, title } = this.state;
		App.setPageTitle(title);

		var css = {};

		if (background != null)
		{
			css.backgroundImage = background;
		}

		return <div className="page homepage">
			<Menu />
			<div className="content" style={ css }>
				<Loading visible={ loading } description={_('Loading')} />
				<Pavilions data={ pavilions } />
			</div>
		</div>;
	}
}

export default Container.create(Homepage);


// WEBPACK FOOTER //
// ./src/modules/pages/homepage.js